import { createContext, useContext } from "react";

export const staticVar = {
  info: "You have unsaved changes. Please save or discard them before proceeding."
}

const ActiveCampusContext = createContext({
  activeCampus: null,
  setActiveCampus: () => undefined,
});
export const useActiveCampusContext = () => useContext(ActiveCampusContext);
export const ActiveCampusContextProvider = ({ children, value }) => (
  <ActiveCampusContext.Provider value={value}>
    {children}
  </ActiveCampusContext.Provider>
);

const ActiveDroneNestContext = createContext({
  droneNests: [],
  activeDroneNest: null,
  setActiveDroneNest: () => undefined,
});
export const useActiveDroneNestContext = () =>
  useContext(ActiveDroneNestContext);
export const ActiveDroneNestContextProvider = ({ children, value }) => (
  <ActiveDroneNestContext.Provider value={value}>
    {children}
  </ActiveDroneNestContext.Provider>
);

const ActiveFloorContext = createContext({
  floors: null,
  activeFloor: null,
  action: null,
  setAction: () => undefined,
  setActiveFloor: () => undefined,
  activeFloorDroneNest: null,
  setActiveFloorDroneNest: () => undefined,
});
export const useActiveFloorContext = () => useContext(ActiveFloorContext);
export const ActiveFloorContextProvider = ({ children, value }) => (
  <ActiveFloorContext.Provider value={value}>
    {children}
  </ActiveFloorContext.Provider>
);

export const sortFloor = (a, b) => b.level - a.level;